import styled from "@emotion/styled";
import { colors } from "../utils/style";

export const Title = styled.h2`
  color: ${colors.text.primary};
  font-size: 16px;
  font-weight: 600;
`;
